export default __webpack_public_path__ + "static/media/stacklr-final-logo.475b9213.png";